import type { AssessmentResult } from "@peer-start/platform-contracts";
import { Card, Disclosure } from "@peer-start/ui";
import { useTranslation } from "react-i18next";
import { KnowledgeStatus } from "./KnowledgeStatus.js";

export function AssessmentAnswerReview({ result }: { result: AssessmentResult }) {
  const { t } = useTranslation();
  return (
    <Card>
      <h2 className="mb-4 text-lg font-medium">{t("knowledgeAssessment.review")}</h2>
      <div className="space-y-2">
        {result.answers.map((answer) => {
          const item = result.definition.items.find((question) => question.id === answer.itemId)!;
          return (
            <Disclosure
              key={item.id}
              controlId={`assessment.review.${item.id}`}
              title={
                <span className="flex flex-wrap items-center gap-2">
                  <span className="text-xs text-muted-foreground">{item.id}</span>
                  <span className="flex-1 text-sm">{item.prompt}</span>
                  <KnowledgeStatus status={answer.outcome} />
                </span>
              }
            >
              <div className="mt-3 space-y-3 text-sm leading-relaxed">
                {item.case ? <p className="text-muted-foreground">{item.case}</p> : null}
                <p>
                  <strong>{t("knowledgeAssessment.yourAnswer")}</strong>{" "}
                  {String.fromCharCode(65 + answer.choice)}. {item.options[answer.choice]} ·{" "}
                  {t(`knowledgeAssessment.confidence.${answer.confidence}`)}
                </p>
                <p>
                  <strong>{t("knowledgeAssessment.correctAnswer")}</strong>{" "}
                  {String.fromCharCode(65 + item.correctOption)}. {item.options[item.correctOption]}
                </p>
                <p className="rounded-lg bg-muted/30 p-3">{item.explanation}</p>
                <p className="text-xs text-muted-foreground">
                  {t("knowledgeAssessment.sources")}:{" "}
                  {item.sourcePartIds
                    .map((id) => {
                      const part = result.definition.courseParts.find((source) => source.id === id)!;
                      return `${part.groupTitle} · ${part.title}`;
                    })
                    .join("; ")}
                </p>
              </div>
            </Disclosure>
          );
        })}
      </div>
    </Card>
  );
}
